import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { DashboardLayout } from "@/components/DashboardLayout";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import BuyerDashboard from "@/pages/buyer/BuyerDashboard";
import NewRFQ from "@/pages/buyer/NewRFQ";
import BuyerRFQs from "@/pages/buyer/BuyerRFQs";
import RFQDetail from "@/pages/RFQDetail";
import OrdersList from "@/pages/OrdersList";
import OrderDetail from "@/pages/OrderDetail";
import SupplierMarketplace from "@/pages/supplier/SupplierMarketplace";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminRFQs from "@/pages/admin/AdminRFQs";

function Dash({ roles, children }) {
  return (
    <ProtectedRoute roles={roles}>
      <DashboardLayout>{children}</DashboardLayout>
    </ProtectedRoute>
  );
}

function HomeRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Landing />;
  return <Navigate to={user.role === "buyer" ? "/buyer" : user.role === "supplier" ? "/supplier" : "/admin"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Buyer */}
            <Route path="/buyer" element={<Dash roles={["buyer"]}><BuyerDashboard /></Dash>} />
            <Route path="/buyer/new-rfq" element={<Dash roles={["buyer"]}><NewRFQ /></Dash>} />
            <Route path="/buyer/rfqs" element={<Dash roles={["buyer"]}><BuyerRFQs /></Dash>} />
            <Route path="/buyer/orders" element={<Dash roles={["buyer"]}><OrdersList /></Dash>} />

            {/* Supplier */}
            <Route path="/supplier" element={<Dash roles={["supplier"]}><SupplierMarketplace /></Dash>} />
            <Route path="/supplier/orders" element={<Dash roles={["supplier"]}><OrdersList /></Dash>} />

            {/* Admin */}
            <Route path="/admin" element={<Dash roles={["admin"]}><AdminDashboard /></Dash>} />
            <Route path="/admin/suppliers" element={<Dash roles={["admin"]}><AdminSuppliers /></Dash>} />
            <Route path="/admin/rfqs" element={<Dash roles={["admin"]}><AdminRFQs /></Dash>} />

            {/* Shared */}
            <Route path="/rfqs/:id" element={<Dash roles={["buyer", "supplier", "admin"]}><RFQDetail /></Dash>} />
            <Route path="/orders/:id" element={<Dash roles={["buyer", "supplier", "admin"]}><OrderDetail /></Dash>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
